/**
 * Enum for LPR camera integration types
 */
export enum LprIntegrationType {
  FLOCK = 'flock',
  FLOCK_V3 = 'flock_v3',
  VIGILANT = 'vigilant',
  FUSUS = 'fusus',
}

/**
 * Enum for LPR camera types
 */
export enum LprCameraType {
  FS_ALPR = 'FS ALPR',
  ALPR = 'ALPR',
  LPR = 'LPR',
}

/**
 * Enum for LPR read types
 */
export enum LprReadType {
  FS_ALPR = 'FS ALPR',
  ALPR = 'ALPR',
  LPR = 'LPR',
}
